<template>
  <gj-link :href="href" target="_blank">
    <slot></slot>
  </gj-link>
</template>

<script>
  import {AdTypeEnum} from "../enum";
  import {defaultVal, queryParamsMap} from "../../../../../utils/common";

  export default {
    name: "app-ad-route-link",
    props: {
      marketId: {
        required: true
      },
      type: {
        type: Number,
        required: true,
        validator: function (value) {
          return [AdTypeEnum.SP, AdTypeEnum.SD, AdTypeEnum.SB].indexOf(value) !== -1
        }
      },
      campaign: {
        type: Object,
        default: null
      },
      group: {
        type: Object,
        default: null
      },
      activeTab: {
        type: String,
        default: null
      },
      groupTargetingType: {
        default: null
      },
    },
    computed: {
      href() {
        let adType = '';
        if (this.type === AdTypeEnum.SP) {
          adType = 'sp-ad';
        } else if (this.type === AdTypeEnum.SD) {
          adType = 'sd-ad';
        } else if (this.type === AdTypeEnum.SB) {
          adType = 'sb-ad';
        }
        return `/ad/${adType}/ad-manager?${queryParamsMap({
          marketId: this.marketId,
          campaignId: this.campaign.campaignId,
          campaignName: this.campaign.campaignName,
          groupId: defaultVal(this.group, {}).groupId,
          groupName: defaultVal(this.group, {}).groupName,
          activeTab: this.activeTab,
          groupTargetingType: this.groupTargetingType
        })}`;
      }
    }
  }
</script>

<style scoped>

</style>
